module.exports = __webpack_public_path__ + "static/carolstran-3aaf00644ac7d2e022531a8f8c701d16.png";